import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "my-report-daily-note-top" }
const _hoisted_3 = { class: "my-report-daily-note-top-container" }
const _hoisted_4 = { class: "my-report-daily-note-top-title" }
const _hoisted_5 = { class: "my-report-daily-note-top-date-wrapper" }
const _hoisted_6 = { class: "my-report-daily-note-top-date-change" }
const _hoisted_7 = {
  key: 1,
  class: "my-report-daily-note-top-date-change-icon"
}
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = {
  key: 3,
  class: "my-report-daily-note-top-date-change-icon"
}
const _hoisted_10 = {
  key: 0,
  class: "my-report-daily-note-container"
}
const _hoisted_11 = { class: "my-report-daily-note-contents" }
const _hoisted_12 = { class: "my-report-daily-note-list" }
const _hoisted_13 = { class: "item-text" }
const _hoisted_14 = { class: "item-bottom" }
const _hoisted_15 = { class: "item-bottom-date" }
const _hoisted_16 = {
  key: 0,
  class: "my-report-daily-note-more-wrapper"
}

import dayjs from "dayjs";
import "dayjs/locale/ja";

import {
  onMounted,
  computed,
  ref,
  reactive,
} from "vue";
import { processing, processend } from "@/utils/view";

import DailyNote from "@/models/myReport/dailyNote";
import { useRouter, useRoute } from "vue-router";
import Header from "@/components/modules/base/Header.vue";
import Footer from "@/components/modules/base/Footer.vue";

// 日付のローカライズ
type DailyNoteType = {
  id: string;
  content: string;
  date: string;
  categoryClass: string;
  categoryLabel: string;
};

// ---- Constants & Variables --------------------------------------------
const activeMenu = "my-report";
const componentId = "generalpurpose03-01-a";

export default /*@__PURE__*/_defineComponent({
  __name: 'MyDailyNote',
  props: {
    yearMonth: { default: dayjs().format("YYYY-MM") },
    returnParams: {}
  },
  setup(__props: any) {

dayjs.locale("ja");

// ---- Props --------------------------------------------
const props = __props;

// ---- Types --------------------------------------------
const router = useRouter();
const route = useRoute();
// 表示制御
const isDataStored = ref<boolean>(false); // データ取得済みフラグ
// 表示データ
const displayCount = ref(20); // 一度に表示する件数
const YearMonth = ref(props.yearMonth);
const dailyNoteItems = ref<DailyNoteType[]>([]);
const prevMonth = ref<string | null>(null);
const nextMonth = ref<string | null>(null);

// 日付表示
const currentYear = computed(() => dayjs(YearMonth.value).year());
const currentMonth = computed(() => dayjs(YearMonth.value).month() + 1);

// ---- Dialogs --------------------------------------------
// エラーダイアログ関連情報
const sessionErr = ref(false);
let errorDialogSet = reactive({
  show: false,
  okButtonHide: true,
  safe: false,
  message: "",
  open: (message: string): void => {
    processing(); // オーバレイを表示
    errorDialogSet.message = message;
    errorDialogSet.show = true;
  },
  close: (): void => {
    processend(); // オーバレイを非表示
    errorDialogSet.show = false;
    errorDialogSet.message = "";
    if (sessionErr.value) {
      window.location.replace("/cms/login");
    }
  },
});

// ---- Event Handlers --------------------------------------
// 前月へ
async function onPrevMonth() {
  if (!prevMonth.value) return;
  YearMonth.value = prevMonth.value;
  await set(); // データ再取得
}

// 次月へ
async function onNextMonth() {
  if (!nextMonth.value) return;
  YearMonth.value = nextMonth.value;
  await set(); // データ再取得
}

// ---- Functions --------------------------------------------
// 日付フォーマット
const formatDate = (date: string | null, fmt: string) => {
  return date ? dayjs(date).format(fmt) : "";
};

// 戻るボタン
const goBack = () => {
  router.push({
    name: returnParams.value.returnRoute,
    params: {
      activeTab: returnParams.value.returnTab,
    },
  });
};

// もっと見る（必要に応じて実装）
const loadMore = () => {
  displayCount.value += 20; // 20件ずつ表示件数を増やす
};

// 表示設定
async function set() {
  isDataStored.value = false; // データ取得前はfalse
  // データ取得
  const dailyNote = new DailyNote();
  const [_model, response, err] = await dailyNote.getData(YearMonth.value);

  // エラー判定
  if (err) {
    const status = err.error.response.status;
    const decodedMessage = decodeURIComponent(
      err.error?.response?.data?.message
    );
    // セッションエラー
    if (status === 408) sessionErr.value = true;
    errorDialogSet.open(decodedMessage);
    return { dailyNotes: [], dailyFeelings: [] };
  }

  // データセット
  dailyNoteItems.value = response.data.dailyNotes;
  prevMonth.value = response.data.prevMonth;
  nextMonth.value = response.data.nextMonth;

  isDataStored.value = true; // データ取得完了
}
// ---- Vue Lifecycle Hooks ------------------------------------
onMounted(async () => await set());
const returnParams = computed(() => ({
  returnTab: (route.query.returnTab as "graph" | "calendar") ?? "graph",
  returnRoute: (route.query.returnRoute as string) ?? "MyReport",
}));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", { id: componentId }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(Header, { "active-menu": activeMenu }),
      _createElementVNode("main", null, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("button", {
            class: "my-report-daily-note-top-back-button",
            onClick: goBack
          }, [
            _cache[0] || (_cache[0] = _createElementVNode("img", {
              src: "/server/necs/images/arrow-right_icon.png",
              alt: ""
            }, null, -1)),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("myreport_note_link_back")), 1)
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("p", null, _toDisplayString(_ctx.$t("myreport_note_title_note")), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              (prevMonth.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "my-report-daily-note-top-date-change-icon",
                    onClick: onPrevMonth
                  }, _cache[1] || (_cache[1] = [
                    _createElementVNode("img", {
                      src: "/server/necs/images/arrow_left_888.svg",
                      alt: ""
                    }, null, -1)
                  ])))
                : (_openBlock(), _createElementBlock("div", _hoisted_7, _cache[2] || (_cache[2] = [
                    _createElementVNode("img", {
                      src: "/server/necs/images/arrow_left_ddd.svg",
                      alt: ""
                    }, null, -1)
                  ]))),
              _createElementVNode("div", {
                class: "my-report-daily-note-top-date-change-period",
                innerHTML: 
                  _ctx.$t('myreport_note_label_period', {
                    currentYear: currentYear.value,
                    currentMonth: currentMonth.value,
                  })
                
              }, null, 8, _hoisted_8),
              (nextMonth.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 2,
                    class: "my-report-daily-note-top-date-change-icon",
                    onClick: onNextMonth
                  }, _cache[3] || (_cache[3] = [
                    _createElementVNode("img", {
                      src: "/server/necs/images/arrow_right_888.svg",
                      alt: ""
                    }, null, -1)
                  ])))
                : (_openBlock(), _createElementBlock("div", _hoisted_9, _cache[4] || (_cache[4] = [
                    _createElementVNode("img", {
                      src: "/server/necs/images/arrow_right_ddd.svg",
                      alt: ""
                    }, null, -1)
                  ])))
            ])
          ])
        ]),
        (isDataStored.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("ul", _hoisted_12, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dailyNoteItems.value.slice(0, displayCount.value), (item) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: item.id,
                      class: "my-report-daily-note-list-item"
                    }, [
                      _createElementVNode("p", _hoisted_13, _toDisplayString(item.content), 1),
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("span", _hoisted_15, _toDisplayString(formatDate(item.date, "YYYY年M月D日(ddd)")), 1),
                        _createElementVNode("div", {
                          class: _normalizeClass(["item-bottom-category", item.categoryClass])
                        }, _toDisplayString(item.categoryLabel), 3)
                      ])
                    ]))
                  }), 128))
                ]),
                (dailyNoteItems.value.length > displayCount.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _createElementVNode("button", {
                        class: "my-report-daily-note-more-button",
                        onClick: loadMore
                      }, [
                        _createTextVNode(_toDisplayString(_ctx.$t("myreport_note_button_more")) + " ", 1),
                        _cache[5] || (_cache[5] = _createElementVNode("img", {
                          src: "/server/necs/images/arrow-right_icon.png",
                          alt: ""
                        }, null, -1))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(Footer, {
        "scroll-target": componentId,
        "active-menu": activeMenu
      })
    ])
  ]))
}
}

})